webpackJsonp([231881910887020],{

/***/ 1934:
/***/ (function(module, exports) {

	module.exports = {"data":{"pageJson":{"slug":"privacy-policy","title":"Privacy Policy | Code Fellows","content":"<div style=\"padding: 3em;\" name=\"termly-embed\" data-id=\"dbd20a14-2d73-49a5-9c43-d3651604bd3c\"></div>\n<script type=\"text/javascript\">(function(d, s, id) {\n  var js, tjs = d.getElementsByTagName(s)[0];\n  if (d.getElementById(id)) return;\n  js = d.createElement(s); js.id = id;\n  js.src = \"https://app.termly.io/embed-policy.min.js\";\n  tjs.parentNode.insertBefore(js, tjs);\n}(document, 'script', 'termly-jssdk'));</script>","keywords":null,"metaDescription":"Code Fellows takes your privacy seriously. Please read the following to learn more about our privacy policy.","imageHeader":null}},"pathContext":{"slug":"privacy-policy"}}

/***/ })

});


// WEBPACK FOOTER //
// path---privacy-policy-93a8369e914c375c7981.js